"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

var _trustpilotUtils = _interopRequireDefault(require("./trustpilotUtils"));

var _utils = require("../../utils");

var _LottieAnimationAPI2 = _interopRequireDefault(require("../LottieAnimationAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var parser = new _uaParserJs.default();

function getBrowserName() {
  return parser.getBrowser().name;
}

var LottieAnimationTrustpilotBase = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(LottieAnimationTrustpilotBase, _LottieAnimationAPI);

  var _super = _createSuper(LottieAnimationTrustpilotBase);

  function LottieAnimationTrustpilotBase(animObj, data, config) {
    var _this;

    _classCallCheck(this, LottieAnimationTrustpilotBase);

    _this = _super.call(this);
    _this.browserName = getBrowserName();
    _this.inputsData = (0, _trustpilotUtils.default)(data.review, config.inputs);
    _this.inDuration = animObj.inDuration || config.inDuration;
    _this.originInDuration = config.inDuration;
    _this.intermissionDuration = config.intermissionDuration;
    _this.outDuration = animObj.outDuration || config.outDuration;
    _this.originOutDuration = config.outDuration;
    _this.totalDuration = config.totalDuration;
    _this.videoScale = animObj.videoScale || 1;
    _this.width = config.width;

    var textLines = _this.inputsData.text.split('\\r').length;

    _this.height = config.lineHeight.base + (textLines - 1) * config.lineHeight.extra;

    if (data.style) {
      _this.style = data.style;
    }

    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(LottieAnimationTrustpilotBase, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      var _this2 = this;

      if (!data || !container) {
        window.console.info('missing data or conatiner');
        return;
      }

      this.container = container;
      var style = {}; // when have style render animation parent whit style to position and size

      if (this.style) {
        var _this$style = this.style,
            width = _this$style.width,
            height = _this$style.height,
            x = _this$style.x,
            y = _this$style.y;
        var videoScale = this.videoScale;
        style = {
          position: 'absolute',
          width: width ? width * videoScale : '100%',
          height: height ? height * videoScale : '100%',
          left: x ? "".concat(x * videoScale, "px") : '0px',
          top: y ? "".concat(y * videoScale, "px") : '0px'
        };
      }

      this.innerContainer = document.createElement('span');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer); // create lottie animation

      data.h = this.height;
      data.w = this.width;
      this.animation = _lottieWeb.default.loadAnimation({
        container: this.innerContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data
      });
      this.animation.addEventListener('DOMLoaded', function () {
        _this2.ready = true;

        _this2.animation.trigger('ready');

        if (typeof _this2.afterReady === 'function') {
          _this2.afterReady();
        }
      });
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      window.console.log('ANIMATION Trustpiolt - prepareAssets');
      return (0, _utils.LoadFonts)();
    }
  }, {
    key: "goToAndStop",
    value: function goToAndStop(time) {
      _get(_getPrototypeOf(LottieAnimationTrustpilotBase.prototype), "goToAndStop", this).call(this, this.getScaledTime(time));
    }
  }, {
    key: "goToIdle",
    value: function goToIdle() {
      var _this3 = this;

      _get(_getPrototypeOf(LottieAnimationTrustpilotBase.prototype), "_validate", this).call(this);

      this.animation.setSpeed(this.originInDuration / this.inDuration);
      this.playSegments([0, this.originInDuration]);
      setTimeout(function () {
        _this3.animation.setSpeed(1);
      }, 100);
    }
  }]);

  return LottieAnimationTrustpilotBase;
}(_LottieAnimationAPI2.default);

exports.default = LottieAnimationTrustpilotBase;